import React from 'react';
import { useTranslation } from 'react-i18next'; // useTranslation hook-ის იმპორტი
import DensimetricSortingtable from "../../../assets/images/DensimetricSortingtable.png";
import OpticalSorting from "../../../assets/images/OpticalSorting.png";
import VibratingSortingTable from "../../../assets/images/VibratingSortingTable.png";
import BeltSortingTable from "../../../assets/images/BeltSortingTable.png";
import FlowRate from "../../../assets/images/FlowRate.png"

function Sorter() {
  const { t } = useTranslation(); // useTranslation hook-ის გამოყენება

  const products = [
    {
      name: t("Densimetric Sorting Table"),
      description: t(
        "Densimetric separation tables allow the gravity dry separation of many materials with different relative specific weight. The densimetric sorting tables are equipped with systems for adjusting the vibration shaker frequency, table inclination, gravity and airflow pressure, guaranteeing high levels of purity of the separated materials."
      ),
      image: DensimetricSortingtable,
    },
    {
      name: t("Optical Sorting"),
      description: t(
        "Optical Sorting Table High-tec sorting table which also has an incorporated AI. It filters out the damaged and unripe berries and also learns in the process, so as to minimize the quality-loss in the long-run."
      ),
      image: OpticalSorting,
    },
    {
      name: t("Vibrating Sorting Table"),
      description: t(
        "Vibrating motion generates a gentle and smooth grape flow, keeping berries intact, and allows for careful visual inspection only to leave ripe grapes that are in perfect condition."
      ),
      image: VibratingSortingTable,
    },
    {
      name: t("High Flow-Rate Sorting Table"),
      description: t(
        "This machine enables a mechanical sorting table with a high flow rate. It enables the removal of leaves, bits of stems, petioles and also pips, skins, raisins and shot berries at high relative speed, therefore allows the user to process bigger quantities."
      ),
      image: FlowRate,
    },
    {
      name: t("Belt Sorting Table"),
      description: t(
        "A belt sorting machine for grapes efficiently separates and sorts grapes based on size, color, and quality. Using conveyor belts it streamlines the sorting process, ensuring the grapes move forward for packing or processing. This automated system increases productivity, reduces labor costs, and enhances overall quality control, making it a must-have for grape harvesters and processors."
      ),
      image: BeltSortingTable,
    },
  ];

  return (
    <div className="main-infocontainer">
      {products.map((product, index) => (
        <div className="item-container" key={index}>
          <img src={product.image} alt={product.name} />
          <div className="text-info">
            <h1>{product.name}</h1>
            <p>{product.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default Sorter;
